import { InitParams, OnboardingData, Platform } from '../schema';
import { joinPaths } from './index';

const DEFAULT_BRAND = 'path';

function getPlatformUrl(platform: Platform): string {
  if (platform) {
    if (platform.toUpperCase() === 'DEMO') {
      return 'https://sdkweb-test.idcheck.io/v2';
    } else {
      return platform;
    }
  }
  return 'https://sdkweb.idcheck.io/v2';
}

function extractFromUrl(url: string): OnboardingData {
  const regex = /(.*)\/(.*)\/(.*)/;
  const match = url.match(regex);
  return {
    platformUrl: match[1],
    brand: match[2],
    uid: match[3],
  };
}

export function getFrameUrl(params: InitParams, platform?: Platform) {
  const extraParams = '?iframe=true';
  if ('url' in params) {
    return `${params.url}${extraParams}`;
  } else {
    const platformUrl = getPlatformUrl(platform);
    return joinPaths(
      platformUrl,
      `/${DEFAULT_BRAND}/${params.uid}${extraParams}`
    );
  }
}

export function extractOnboardingData(
  params: InitParams,
  platform?: Platform
): OnboardingData {
  if ('url' in params) {
    return extractFromUrl(params.url);
  } else {
    return {
      platformUrl: getPlatformUrl(platform),
      uid: params.uid,
      brand: DEFAULT_BRAND,
    };
  }
}
